import React from 'react';
import styled from 'styled-components';
import Downloads from './Downloads';

const Svg = styled.svg`
  transform: rotate(180deg);
`;

export default class Replace extends Downloads {
  icon = (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 25"
      data-testid={this.props['data-testid']}
    >
      <path fill="currentColor" fillRule="evenodd" d={this.iconContent} />
    </Svg>
  );
}
